import loadable from "@loadable/component";

export const LockersList = loadable(() => import("./lockers-list/list"));
export const LockerDetail = loadable(() => import("./lockers-list/detail"));
export const ParcelLockersList = loadable(
  () => import("./parcel-lockers/list")
);
